import IconTemplate from '../IconTemplate';
export default IconTemplate('M 4 8 h 16 V 4 H 4 v 4 z m 0 12 h 16 v -4 h -16 v 4 z m 0 -6 h 16 v -4 H 4 v 4 z');